module.exports = __webpack_public_path__ + "static/media/reply.b36eb48d.svg";